<mat-form-field appearance="outline" class="date-picker-field">
  <mat-label>Consent Date</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="dateControl" [min]="minDateAsDate" />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker panelClass="app-datepicker-panel"></mat-datepicker>
</mat-form-field>
